/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SparklesIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABO0lEQVR4nOVUO07DUBB0BwW5AYI7ABJ0tBbyfozk7BKKVAlnCVcCcQIUmoQOU8ElghW0USAvsR2ePwWCkVay7KeZ3Zn1C4J/jSRJ9oDl0cqeWxdA1gGyzq2AZdgq+Xm/vwus05WATsMw3GlMjIgd6xZIn7/IVyWTxVSIndoCwPKUJ14vYBn/DgGIu2dA8g4sb4h6au9sfLPB9d/NwezztghYHxyC+1zIaznIpFLIF5e9QyDJvrsjyaIoOXDPEF3dOA0MvMkX3ZPeFmzJqGCjxlbetliXS/JZQYAz+7Y5iRcQ9QRY71xbSreEJLOzzL1jf0tYX38ixnyl/hOwppUFSF68BWzcqhZFcfcoqAoL0LalLGRkGdUKeRNLkfm2NW2EOL7eB9KPbT9aY9j1UHZVtAILfrldaa1A/wQ+Adf4P/Css0cCAAAAAElFTkSuQmCC)
 */
export const SparklesIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.14 2.8a1.21 1.21 0 0 0-2.28 0l-.5 1.37a2 2 0 0 1-1.19 1.18l-1.38.51a1.21 1.21 0 0 0 0 2.28l1.38.5a2 2 0 0 1 1.18 1.19l.51 1.38a1.21 1.21 0 0 0 2.28 0l.5-1.38a2 2 0 0 1 1.19-1.18l1.38-.51a1.21 1.21 0 0 0 0-2.28l-1.38-.5a2 2 0 0 1-1.18-1.19l-.51-1.38ZM10.6 9.11a1.7 1.7 0 0 0-3.2 0l-.84 2.27a2 2 0 0 1-1.18 1.18l-2.27.85a1.7 1.7 0 0 0 0 3.18l2.27.85a2 2 0 0 1 1.18 1.18l.85 2.27a1.7 1.7 0 0 0 3.18 0l.85-2.27a2 2 0 0 1 1.18-1.18l2.27-.85a1.7 1.7 0 0 0 0-3.18l-2.27-.85a2 2 0 0 1-1.18-1.18l-.85-2.27Z"
        className={colorClass}
      />
    </svg>
  );
};
